// Registro central das bandeiras de cartão aceitas (Asaas)
// Ícones inline (SVG) — não geram requisições HTTP em runtime
import { VisaIcon } from './Visa';
import { MastercardIcon } from './Mastercard';
import { EloIcon } from './Elo';
import { DinersIcon } from './Diners';
import { DiscoverIcon } from './Discover';
import { AmexIcon } from './Amex';
import { CabalIcon } from './Cabal';
import { BanescardIcon } from './Banescard';
import { CredzIcon } from './Credz';
import { SorocredIcon } from './Sorocred';
import { CredsystemIcon } from './Credsystem';
import { JcbIcon } from './Jcb';

export type AcceptedBrand = {
  id: string;
  label: string;
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
};

// Ordem segue o exemplo visual aprovado (image 4)
export const ACCEPTED_BRANDS: ReadonlyArray<AcceptedBrand> = [
  { id: 'visa', label: 'Visa', Icon: VisaIcon },
  { id: 'mastercard', label: 'Mastercard', Icon: MastercardIcon },
  { id: 'elo', label: 'Elo', Icon: EloIcon },
  { id: 'diners', label: 'Diners Club', Icon: DinersIcon },
  { id: 'discover', label: 'Discover', Icon: DiscoverIcon },
  { id: 'amex', label: 'American Express', Icon: AmexIcon },
  { id: 'cabal', label: 'Cabal', Icon: CabalIcon },
  { id: 'banescard', label: 'Banescard', Icon: BanescardIcon },
  { id: 'credz', label: 'Credz', Icon: CredzIcon },
  { id: 'sorocred', label: 'Sorocred', Icon: SorocredIcon },
  { id: 'credsystem', label: 'Credsystem', Icon: CredsystemIcon },
  { id: 'jcb', label: 'JCB', Icon: JcbIcon },
];
